import React from 'react';
import PropTypes from 'prop-types';
import packageJson from '../../package.json';
global.appVersion = packageJson.version;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

class CacheBuster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            refreshCacheAndReload: () => {
                console.log('Clearing cache and hard reloading...')
                if (caches) {
                    // Service worker cache should be cleared with caches.delete()
                    caches.keys().then(function (names) {
                        for (let name of names) caches.delete(name);
                    });
                }

                // delete browser cache and hard reload
                window.location.reload(true);
            }
        };
    }

    // componentDidMount() {
    //     // Check version when component mounts
    //     this.checkVersion();
    // }

    componentDidMount() {
        fetch('/meta.json')
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;

                const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
                if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    this.setState({ loading: false, isLatestVersion: false });
                } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    this.setState({ loading: false, isLatestVersion: true });
                }
            });
    }

    checkVersion = async () => {
        try {
            // Get version from localStorage
            const storedVersion = localStorage.getItem('appVersion');
            const bundleVersion = global.appVersion;
            
            // Fetch meta.json file from server with cache busting to always get the latest
            const response = await fetch('/meta.json', {
                cache: 'no-cache',
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch version');
            }

            const meta = await response.json();
            const latestVersion = meta.version;
            const currentVersion = storedVersion || bundleVersion;

            // If no version in localStorage, handle first-load logic
            if (!storedVersion) {
                localStorage.setItem('appVersion', latestVersion);

                const shouldForceRefreshFirstLoad = semverGreaterThan(latestVersion, bundleVersion);
                if (shouldForceRefreshFirstLoad) {
                    console.log(`First-load update detected! Bundle: ${bundleVersion}, Latest: ${latestVersion}`);
                    this.setState({ loading: false, isLatestVersion: false });

                    if (this.props.onVersionUpdate) {
                        this.props.onVersionUpdate(latestVersion);
                    }

                    setTimeout(() => {
                        this.state.refreshCacheAndReload();
                    }, 2000);
                    return;
                }

                this.setState({ loading: false, isLatestVersion: true });
                return;
            }

            // Compare versions
            const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
            if (shouldForceRefresh) {
                console.log(`New version detected! Current: ${currentVersion}, Latest: ${latestVersion}`);
                // Save new version before reload
                localStorage.setItem('appVersion', latestVersion);
                this.setState({ loading: false, isLatestVersion: false });
                
                // Show notification and reload after 2 seconds
                if (this.props.onVersionUpdate) {
                    this.props.onVersionUpdate(latestVersion);
                }
                
                setTimeout(() => {
                    this.state.refreshCacheAndReload();
                }, 2000);
            } else {
                console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                this.setState({ loading: false, isLatestVersion: true });
            }
        } catch (error) {
            console.error('Error checking version:', error);
            // If error, still allow app to run with old version
            this.setState({ loading: false, isLatestVersion: true });
        }
    };

    render() {
        const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
        return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
    }
}

export default CacheBuster;

CacheBuster.propTypes = {
    onVersionUpdate: PropTypes.func,
    children: PropTypes.func.isRequired
};

CacheBuster.defaultProps = {
    onVersionUpdate: null
};